/** Only same-origin app routes; URLSearchParams has already decoded the query. */
export function safeAuthReturn(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || (value.includes('\\') || [...value].some(c => c.charCodeAt(0) <= 32))) return '/';
  try {
    const url = new URL(value, 'https://forex.invalid');
    if (url.origin !== 'https://forex.invalid' || /^\/auth(?:\/|$)/.test(url.pathname)) return '/';
    return url.pathname + url.search + url.hash;
  } catch { return '/'; }
}
